import { Reveal, Overline } from "@/components/Reveal";
import { CircuitTraces } from "@/components/Vectors";

export default function PageHero({ overline, title, sub, artwork }) {
  return (
    <section className="relative pt-36 pb-16 md:pb-20 overflow-hidden bg-bone">
      <div className="absolute inset-0 grid-lines pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-[1fr_auto] gap-10 items-center">
        <Reveal>
          <Overline>{overline}</Overline>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] max-w-3xl text-ink">
            {title}
          </h1>
          {sub && <p className="mt-6 text-base md:text-lg max-w-2xl leading-relaxed text-zinc-600">{sub}</p>}
        </Reveal>
        {artwork && <div className="hidden lg:block w-[320px] xl:w-[360px]">{artwork}</div>}
      </div>
      <CircuitTraces light className="absolute bottom-0 left-0 w-full h-14 opacity-70 pointer-events-none" />
    </section>
  );
}
